import sarSvg from '@/assets/sar-symbol.svg';

interface SarSymbolProps {
  className?: string;
  size?: number;
}

/**
 * Saudi Riyal currency symbol — official 2022 glyph.
 * Use this component wherever SAR currency is displayed.
 */
const SarSymbol = ({ className = '', size = 14 }: SarSymbolProps) => (
  <img
    src={sarSvg}
    alt="SAR"
    width={size}
    height={size}
    className={`inline-block align-middle ${className}`}
    style={{ verticalAlign: 'middle' }}
    draggable={false}
  />
);

export default SarSymbol;
